import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Siteregistration from '../Sitemanagementmain/Siteregitration'

function Sitemanagement() {
   return (
      <Routes>
          <Route path="/" element={<Siteregistration />} />
          <Route path="register" element={<Siteregistration />} />
      </Routes>
    )
}

export default Sitemanagement;
